// extracted by mini-css-extract-plugin
module.exports = {"theComp":"Media_theComp__E2avL"};